<template>
  <div class="components__rec-component-collection" v-bind:class="[{ framed: description.framed }, frameCssClass]">
    <div
      v-bind:class="{ distanced: description.distanced }"
      v-for="component in description.components"
      v-bind:key="component.id"
      class="single-component"
    >
      <component
        v-bind:is="component.component"
        v-bind:description="component"
        v-bind:class="{ 'print--hide': component.print_hide }"
        v-on:submit="$emit('submit')"
        v-on:submit-as-draft="$emit('submit-as-draft')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.components__rec-component-collection {
  .single-component {
    &.distanced {
      margin-bottom: 20px;
    }
  }

  // framed collections carry the border from the curriculum theming class
  &.framed {
    border-width: 2px;
    padding: 20px 25px;
    // set the framed block apart from the fields following it
    margin-bottom: 15px;

    .single-component:not(:last-child) {
      margin-bottom: 20px;
    }
  }
}
</style>

<script lang="ts" setup>
  import { themingCssClasses } from '../../mixins/theming-mixin';
  import { recProps } from '../../mixins/rec-component';

  const props = defineProps({...recProps()});

  const frameCssClass = props.description.framed ? themingCssClasses(['border', 'light_background']) : '';
</script>
